import { PositionResult } from "common/position/dto/PositionResult";

export const positionFormDefaultValuesGet = (position?: PositionResult) => {
  if (position) {
    return {
      datum: position.datum,
      title: position.title,
      fileName: position.fileName,
    };
  } else {
    return {
      datum: new Date(),
      title: "",
      fileName: "",
    };
  }
};
